module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"newVacancy":"Новая вакансия"}}')
  delete Component.options._Ctor
}
